// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gv-6";
export var emphasizeQuantity = "_gv-3";
export var flatBottomCorners = "_gv-5";
export var productImage = "_gv-0";
export var quantityContainer = "_gv-2";
export var tooltip = "_gv-1";
export var wrapAndEllipsesOverflow = "_gv-4";